export enum MODULES_PERMISSIONS {
    DIRECTORY_EDIT = 'DIRECTORY_EDIT',
    TUTORIAL_EDIT = 'TUTORIAL_EDIT',
    USER_DIRECTORY_EDIT = 'USER_DIRECTORY_EDIT',
}
